import { cn } from "@uconnect/assets/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
	return (
		<div
			data-slot="skeleton"
			className={cn("bg-accent animate-pulse rounded-md text-transparent!", className)}
			aria-hidden="true"
			{...props}
		/>
	)
}

export { Skeleton }
